exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EditorToolbar__root___2mV5z {\n  font-family: 'Helvetica', sans-serif;\n  font-size: 14px;\n  margin: 0 10px;\n  padding: 10px 0 5px;\n  border-bottom: 1px solid #ddd;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.EditorToolbar__onBottom___1ADkE {\n  border-top: 1px solid #ddd;\n  border-bottom: none;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "EditorToolbar__root___2mV5z",
	"onBottom": "EditorToolbar__onBottom___1ADkE"
};


//////////////////
// WEBPACK FOOTER
// ../css-loader/dist/cjs.js??ref--2-1!../react-rte/lib/lib/EditorToolbar.css
// module id = 2043
// module chunks = 22